import { DISCORD_INVITE_URL } from "@gadgetinc/widgets";
import { APIPlaygroundIcon } from "@gadgetinc/widgets/src/icons/APIPlaygroundIcon";
import { GraphQLAPIPlaygroundIcon } from "@gadgetinc/widgets/src/icons/GraphQLAPIPlaygroundIcon";
import { useStyletron } from "baseui";
import React, { useContext } from "react";
import { DocsContext } from "../chrome/DocsContext";
import { DocLink } from "./DocLink";

export { Anchor } from "web/src/components/edit/shared/Anchor";
export { Image } from "web/src/components/markdown/Image";
export { ListItem, OrderedList, UnorderedList } from "web/src/components/markdown/ListItems";
export { Mermaid } from "web/src/components/markdown/Mermaid";
export { Table, TD, TH, TR } from "web/src/components/markdown/Table";
export { Blockquote, InlineCode, Paragraph } from "web/src/components/markdown/Typography";
export { Video } from "web/src/components/markdown/Video";
export { Flag } from "web/src/lib/flags";
export { AsciinemaPlayer } from "./AsciinemaPlayer";
export { Callout } from "./Callout";
export { CodeBlock } from "./CodeBlock";
export { CodeDiff } from "./CodeDiff";
export { DocLink } from "./DocLink";
export { DocsTabs } from "./DocsTabs";
export { EmbeddedVideo } from "./EmbeddedVideo";
export { ForkButton, ForkButtonCallout } from "./ForkButtonCallout";
export { FrameworkVersionPill } from "./FrameworkVersionPill";
export { H1, H2, H3, H4, H5, H6 } from "./Headings";
export { InlineTsFilePath, TsFilePath } from "./InlineTsFilePath";
export { LanguageDependantContent } from "./LanguageDependantContent";
export { LanguageDependantImage } from "./LanguageDependantImage";
export { MarkdownComponents } from "./MarkdownComponents";
export { OnClickLink } from "./OnClickLink";
export { Pill } from "./Pill";
export { APIReferenceRelativeLink, ExampleFallbackAPIReferenceRelativeLink } from "./RelativeLinks";
export { SearchBoost } from "./SearchBoost";
export { TabbedCodeExample } from "./TabbedCodeExample";
export { TableHeadCell as TableHead } from "./TableHeadCell";
export { TableRow } from "./TableRow";
export { TranspiledCodeExample } from "./TranspiledCodeExample";

export const DiscordLink = () => <DocLink href={DISCORD_INVITE_URL}>Discord</DocLink>;

export const APIPlaygroundLink = () => {
  const [css, $theme] = useStyletron();
  const context = useContext(DocsContext);

  return (
    <DocLink href={`${context.currentApp.canonicalRenderURL}api/playground/javascript?environment=${context.currentApp.environment.slug}`}>
      <span className={css({ verticalAlign: "middle" })}>{<APIPlaygroundIcon />}</span>&nbsp;
      {context.currentApp.slug} API playground
    </DocLink>
  );
};

export const GraphQLPlaygroundLink = () => {
  const [css, $theme] = useStyletron();
  const context = useContext(DocsContext);

  return (
    <DocLink href={`${context.currentApp.canonicalRenderURL}api/playground/graphql?environment=${context.currentApp.environment.slug}`}>
      <span className={css({ verticalAlign: "middle" })}>{<GraphQLAPIPlaygroundIcon />}</span>&nbsp;
      {context.currentApp.slug} GraphQL playground
    </DocLink>
  );
};
